import { render, staticRenderFns } from "./EditDialog3.vue?vue&type=template&id=2aabd8c8&scoped=true&"
import script from "./EditDialog3.vue?vue&type=script&lang=js&"
export * from "./EditDialog3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabd8c8",
  null
  
)

export default component.exports